export default function ($rootScope, $scope, $stateParams, $http, $uibModal, $state, $q, $timeout, CONFIG, ngToast, Upload, UtilitiesFactory, ContentFulFactory) {
    'ngInject';

    let idFile = $stateParams.id;
    let utilities = UtilitiesFactory.getUtilities();
    let T = $scope.$root.T;

    $scope.hidden = !!!idFile;
    $scope.articlesUsed = [];
    $scope.setControlsToDirty = utilities.forms.setControlsToDirty;
    $scope.file = {};
    $scope.isDone = false;

    $rootScope.$broadcast('selectionMenu', {context: ''});

    $scope.$watch('dirtyElems', function (dirty) {
        console.log('dirtyElems', dirty);
        if (dirty) {
            $rootScope.preventNavigation();
        }
        else {
            $rootScope.allowNavigation();
        }
    });


    let getSelectedFile = () => {
        let endpoint = `assets?include=10&sys.id=${idFile}&sys.type[ne]=${(new Date()).valueOf()}`;
        console.log('getSelectedFile()', endpoint);
        $http.get(`${CONFIG.customUploadUrl}contentful/${endpoint}`).then( (data) => {
            let _dataAssets = data.data;
            $scope.file = _dataAssets.items[0].fields;
            console.log($scope.file);

            // https://cdn.contentful.com/spaces/erjaey3bjggb/entries/?access_token=a679712c0a5df3e639063cc9e90b17ba409a064d22920319b4b256977010e620&include=5&fields.images.sys.id=38hL3reEaIQW26ywAWO2WU&content_type=article
            $http.get(`${CONFIG.customUploadUrl}contentful/entries?content_type=article&include=5&fields.images.sys.id=${idFile}&sys.type[ne]=${(new Date()).valueOf()}`).then((data) => {
                let _data = data.data;
                let entries = _data.hasOwnProperty('includes') ? _data.includes.Entry : [];
                $scope.articlesUsed = _data.items;

                _.map($scope.articlesUsed, (article) => {
                    let region = article.fields.hasOwnProperty('region') ? article.fields.region : null;

                    if (!!region) {
                        let regionObj = _.filter(entries, (entry) => { return entry.sys.id === region.sys.id; });
                        article.fields.region.title = regionObj[0].fields.title;
                    }
                });
            });
        });
    };


    /***
     *
     * @param value
     */
    $scope.changed = (value) =>{
        console.log(value, $rootScope.dirtyElems);
        $rootScope.dirtyElems = true;
    };

    /***
     * Success Upload Image Callback
     * @param asset
     */
    let imageSuccessCallback = (asset) => {
        console.log(asset);
        $scope.isProgress = false;
        ngToast.create({
            className: 'toast-success',
            content: `${T.FILE} ${T.HTTP_POST_SUCCESS_NOTIFICATION}`,
            timeout: 4000
        });

        $rootScope.dirtyElems = true;
        $state.go('^.file', {id: asset.sys.id});
    };

    /***
     * Error Message Callback
     */
    let imageErrorCallback = () => {
        $timeout( () => {
            $scope.isProgress = false;
            ngToast.create({
                className: 'toast-danger',
                content: `${T.HTTP_UPLOAD_ERROR_NOTIFICATION}`,
                timeout: 6000
            });
        });
    };

    /***
     * Upload Files
     * @param files
     */
    $scope.uploadFiles = (files) => {
        if (files.length > 0) {
            $scope.file.file = _.first(files);
        }
    };

    /***
     * Submit
     */
    $scope.submit = () => {
        $scope.isProgress = true;
        $rootScope.dirtyElems = false;

        if (!$scope.isDone) {
            $scope.isDone = true;
            console.log('submit');
            if (!!$scope.file.file.url) {
                ContentFulFactory.createAssetFromFiles()
                    .then((space) => space.getAsset(idFile))
                    .then((asset) => {
                        console.warn('asset', asset);
                        asset.fields.title = {
                            en: $scope.file.title
                        };
                        if (!!$scope.file.description) {
                            asset.fields.description = asset.fields.hasOwnProperty('description') ? asset.fields.description : {};
                            asset.fields.description = {
                                en:  $scope.file.description
                            };
                        }
                        return asset.update()
                    })
                    .then((asset) => {
                        return asset.publish();
                    })
                    .then((asset) => {
                        console.log(asset);
                        $scope.isDone = false;
                        $timeout( () => {
                            $state.reload();
                        }, 300)
                    })
                    .catch((error) => {
                        console.error('submit: ', error)
                    })
            } else {
                Upload.upload({
                    url: `${CONFIG.customUploadUrl}upload`,
                    data: {file: $scope.file.file }
                }).then( (data) => {
                    ContentFulFactory.createAssetFromFiles()
                        .then((space) => {
                            /**
                             * Create new asset
                             */
                            space.createAsset({
                                fields: {
                                    title: {
                                        'en': $scope.file.title
                                    },
                                    description: {
                                        'en': $scope.file.description
                                    },
                                    file: {
                                        'en': {
                                            contentType: $scope.file.file.type,
                                            fileName: $scope.file.file.$ngfName || $scope.file.file.name,
                                            upload: data.data.url
                                        }
                                    }
                                }
                            })
                                .then((asset) => {
                                    /**
                                     * Processing asset
                                     */
                                    console.log('processing...', asset);
                                    let p1 = asset.processForLocale('en', { processingCheckWait: 500, processingCheckRetries: 20 });
                                    p1.then((value) => {
                                        console.log('value', value);
                                    }).catch((e) => {
                                        $scope.isDone = false;
                                        let errorMessage = `${e.data.message} - id: ${e.data.details.id}`;
                                        $rootScope.raven.captureException(errorMessage);
                                        $rootScope.raven.showReportDialog();
                                        imageErrorCallback(e);
                                    }).then((error) => {
                                        $scope.isDone = false;
                                        console.log(error);
                                    }, (e) => {
                                        $scope.isDone = false;
                                        let errorMessage = `${e.data.message} - id: ${e.data.details.id}`;
                                        $rootScope.raven.captureException(errorMessage);
                                        $rootScope.raven.showReportDialog();
                                    });

                                    return p1;
                                })
                                .then((asset) => {
                                    /**
                                     * Publishing asset
                                     */
                                    console.log('publishing...', asset);

                                    return asset.publish();
                                })
                                .then((asset) => {
                                    let createdAsset = asset;

                                    $timeout( () => {

                                        ContentFulFactory.createAssetFromFiles()
                                            .then((space) => space.getAsset(idFile))
                                            .then((asset) => {
                                                console.warn('asset', asset);
                                                asset.fields.title = {
                                                    en: $scope.file.title
                                                };
                                                if (!!$scope.file.description) {
                                                    asset.fields.description = asset.fields.hasOwnProperty('description') ? asset.fields.description : {};
                                                    asset.fields.description = {
                                                        en:  $scope.file.description
                                                    };
                                                }

                                                /***
                                                 * Update the asset with the new one, created before.
                                                 */
                                                asset.fields.file = createdAsset.fields.file;
                                                asset.fields.file.en.url = `https:${createdAsset.fields.file.en.url}`;
                                                return asset.update()
                                            })
                                            .then((asset) => {
                                                return asset.publish();
                                            })
                                            .then((asset) => {
                                                console.log(asset);
                                                $timeout( () => {
                                                    ContentFulFactory.createAssetFromFiles()
                                                        .then((space) => space.getAsset(createdAsset.sys.id))
                                                        .then((asset) => asset.unpublish())
                                                        .then((asset) => asset.delete())
                                                        .then((asset) => {
                                                            $scope.isDone = false;
                                                            $state.reload();
                                                        });
                                                }, 300)
                                            })
                                    }, 300)

                                })
                        });
                }, (error) => {
                    $scope.error = error;
                    $scope.isDone = false;
                });
            }
        }
    };


    /***
     * Dismiss
     */
    $scope.dismiss = () => {
        console.log('dismiss');
        $state.reload();
    };

    if (!!idFile) {
        getSelectedFile();
    }
}



// WEBPACK FOOTER //
// ./src/app/views/app.file/appFileCtrl.js